import React, { Component } from 'react'
import {GetUnsubscriberByRecipientHash, UnsubscribeByRecipientHash
} from 'actions'
import {connect} from 'react-redux'
import {Card, TextField, Button, Grid, Typography} from '@material-ui/core'
import { isEmpty } from 'lodash'
import IntlMessages from 'util/IntlMessages';

class MailUnsub extends Component {
  state={
    currentContact : [],
    isLoading: false,
    reason: ''
  }

  componentDidMount() {
    this.props.GetUnsubscriberByRecipientHash(this.props.match.params.Contact_Hash).then((currentContact) => {
      this.setState({currentContact})
    })
  }

  handleUnsub = () => {
    this.setState({isLoading: true})
    this.props.UnsubscribeByRecipientHash(this.props.match.params.Contact_Hash, this.state.reason).then((currentContact) => {
      this.setState({currentContact, isLoading: false})
    }).catch((err) => {
      this.setState({isLoading: false})
    })
  }

  render() {
    return (
      <div style={{width: '100%', height: '100%', backgroundColor: '#F4F4F4'}} className='d-flex align-items-center justify-content-center'>
        {
          !isEmpty(this.state.currentContact) &&
          <Card className='p-3' style={{width: '100%', maxWidth: '450px'}}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography component="h3" className='text-dark-md' align='center'><IntlMessages id="Label.Deregistration"/></Typography>
              </Grid>
              <Grid item xs={12}>
              {
                isEmpty(this.state.currentContact) ? '' :
                (
                  (parseInt(this.state.currentContact[0]?.isSubscribe) === 0) ?
                  <p className='text-center text-dark-md'>
                    <IntlMessages id="Label.Deregistration.Body"/>
                  </p>
                  :
                  <TextField 
                    disabled={isEmpty(this.state.currentContact) || (parseInt(this.state.currentContact[0]?.isSubscribe) === 0)}
                    fullWidth
                    variant='outlined'
                    multiline
                    value={this.state.reason}
                    label={<IntlMessages id="Label.Reason"/>}
                    size="small"
                    rows={8}
                    rowsMax={10}
                    onChange={(e) => this.setState({reason: e.target.value})}
                    />
                )
              }
              </Grid>
              <Grid item xs={12}>
                <Button 
                disabled={isEmpty(this.state.currentContact) || (parseInt(this.state.currentContact[0]?.isSubscribe) === 0) || this.state.isLoading}
                size="small" fullWidth onClick={this.handleUnsub} color="secondary" variant="outlined">
                  {isEmpty(this.state.currentContact) ? 'Avregistrera' : (parseInt(this.state.currentContact[0]?.isSubscribe) === 0 ? <IntlMessages id="Label.unregistered"/> : <IntlMessages id="Label.Unregister"/>)}
                </Button>
              </Grid>
            </Grid>
          
          </Card>
        }
        {/* {this.props.match.params.Contact_Hash} {JSON.stringify(this.state.currentContact)} */}
        </div>
    )
  }
}
const mapStateToProps = ({})=> {
  return {
  };
}
const mapDispatchToProps=(dispatch)=> {
  return {
    GetUnsubscriberByRecipientHash: (RecipientHash) => dispatch(GetUnsubscriberByRecipientHash(RecipientHash)),
    UnsubscribeByRecipientHash: (RecipientHash, Reason) => dispatch(UnsubscribeByRecipientHash(RecipientHash, Reason)),
    dispatch 
  };
}

export default connect(mapStateToProps,mapDispatchToProps)(MailUnsub)
